/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Synchronizing_VaultInputs */

const en_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizing Vault...`)
};

const es_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizando bóveda...`)
};

const fr_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation du coffre-fort...`)
};

const de_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault wird synchronisiert...`)
};

const ja_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫を同期中...`)
};

const zh_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步金库中...`)
};

const ar_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري مزامنة الخزنة...`)
};

const id_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyinkronkan Vault...`)
};

const it_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizzazione Vault in corso...`)
};

const ru_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация Хранилища...`)
};

const pt_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizando Cofre...`)
};

const ko_synchronizing_vault = /** @type {(inputs: Synchronizing_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보관소(Vault) 동기화 중...`)
};

/**
* | output |
* | --- |
* | "Synchronizing Vault..." |
*
* @param {Synchronizing_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const synchronizing_vault = /** @type {((inputs?: Synchronizing_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Synchronizing_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_synchronizing_vault(inputs)
	if (locale === "es") return es_synchronizing_vault(inputs)
	if (locale === "fr") return fr_synchronizing_vault(inputs)
	if (locale === "de") return de_synchronizing_vault(inputs)
	if (locale === "ja") return ja_synchronizing_vault(inputs)
	if (locale === "zh") return zh_synchronizing_vault(inputs)
	if (locale === "ar") return ar_synchronizing_vault(inputs)
	if (locale === "id") return id_synchronizing_vault(inputs)
	if (locale === "it") return it_synchronizing_vault(inputs)
	if (locale === "ru") return ru_synchronizing_vault(inputs)
	if (locale === "pt") return pt_synchronizing_vault(inputs)
	return ko_synchronizing_vault(inputs)
});